/**
  * @prop --default-badge: Background color for a default badge
  * @prop --neutral-badge: Background color for a neutral badge
  * @prop --info-badge: Background color for an info badge
  * @prop --success-badge: Background color for a success badge
  * @prop --error-badge: Background color for an error badge
  * @prop --warning-badge: Background color for a warning badge
  * @prop --dark-text: Dark text-color used on light backgrounds
  * @prop --light-text: Light text-color used on dark backgrounds
  * @prop --badge-color: Text color used for the number
  * @prop --badge-font-weight: Font weight used for the number
  * @prop --badge-font-size: Font size used for the number
  * @prop --badge-font-family: Font family used for the number
  * @prop --badge-line-height: Size of the badge relative to the font size
  * @prop --badge-background-color: Background color used on the badge
  * @prop --badge-spacing: Size used for the left and right padding
  * @prop --badge-border-radius: Border radius used for the corners (equals the line-height by default)
  */

:host {
  --default-badge: var(--s-color-background-contrast);
  --neutral-badge: var(--s-color-background-default-default);
  --info-badge: var(--b-color-info-default);
  --success-badge: var(--b-color-succes-default);
  --error-badge: var(--b-color-error-default);
  --warning-badge: var(--b-color-warning-default);

  --dark-text: var(--s-color-text-default);
  --light-text: var(--s-color-text-on-dark-default);

  --badge-color: var(--dark-text);
  --badge-font-weight: var(--s-font-weight-paragraph-emphasized);
  --badge-font-size: var(--s-size-text-default);
  --badge-font-family: var(--s-font-family-paragraph);
  /*
    can't use the typography line-height default, as it is 24px and not 1.5
    and this messes with the spacing and border calculation
  */
  --badge-line-height: var(--p-size-dynamic-300);

  --badge-background-color: var(--default-badge);

  /* 
    adjust spacing based on font-size and line-height
    if consumer for some reason changes the font-size,
    the border-radius will always be correct and give the badge its "roundness"
  */
  --badge-spacing: var(--p-size-static-100);
  --badge-border-radius: calc(var(--badge-line-height) + var(--badge-font-size));

  .badge {
    background-color: var(--badge-background-color);
    color: var(--badge-color);
    background-color: var(--badge-background-color);
    padding: 0 var(--badge-spacing);
    line-height: var(--badge-line-height);
    border-radius: var(--badge-border-radius);
    font-weight: var(--badge-font-weight);
    font-family: var(--badge-font-family);
    font-size: var(--badge-font-size);
  }
  .default,
  .error,
  .info,
  .success {
    --badge-color: var(--light-text);
  }
  .default {
    --badge-background-color: var(--default-badge);
  }
  .neutral {
    --badge-background-color: var(--neutral-badge);
  }
  .warning {
    --badge-background-color: var(--warning-badge);
  }
  .info {
    --badge-background-color: var(--info-badge);
  }
  .error {
    --badge-background-color: var(--error-badge);
  }
  .success {
    --badge-background-color: var(--success-badge);
  }
}
